import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/hostelWorldActions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchHwRates = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.HW_RATES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.hwRatesFind, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.hw_fetchRatesSuccess(getParser(urls.hwRates)(json))))
        .catch(
            handleError(
                dispatch,
                actions.hw_fetchRatesFailure,
                'Что-то пошло не так!',
                'При получении тарифов произошла ошибка'
            )
        )
}

/** @thunk **/
export const reloadHwRate = payload => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    }
    const { auth } = getState()

    securedFetch(urls.reloadRatesFromHw, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.hw_saveRatesSuccess(json)))
        .catch(handleError(dispatch, actions.hw_saveRatesFailure, 'Тариф не найден!', 'Ну или произошла ошибка'))
}

/** @thunk **/
export const deleteHwRate = ourId => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.hwRateSelf(ourId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.hw_deleteRateSuccess(ourId)))
        .then(() => toastr.success('Тариф удален'))
        .catch(
            handleError(
                dispatch,
                actions.hw_deleteRateFailure,
                'Что-то пошло не так!',
                'При удалении тфрифа произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/hostelWorldApi/hwRates.js